import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IinitialState {
  isOpenSidebar: boolean;
  userInfo: any;
}

const initialState: IinitialState = {
  isOpenSidebar: true,
  userInfo: null,
};

export const dashboardLayoutSlide = createSlice({
  name: "dashboardLayoutSlide",
  initialState,
  reducers: {
    toggleSidebar(state, action: PayloadAction<boolean>) {
      state.isOpenSidebar = action.payload;
    },
    checkPermissionUser(state, action: PayloadAction<any>) {
      state.userInfo = action.payload;
    },
  },
});

export const dashboardLayoutReducer = dashboardLayoutSlide.reducer;
